<div class="h-full w-full rounded-2xl shadow-lg overflow-hidden relative">
  <!-- Background slides for smoother transitions -->
  <div
    *ngFor="let slide of slides; let i = index"
    class="inset-0 absolute transition-opacity duration-1000 ease-in-out"
    [class.opacity-100]="i === currentIndex"
    [class.opacity-0]="i !== currentIndex"
  >
    <!-- Image slide -->
    <ts-picture
      *ngIf="!slide.bg_video"
      class="inset-0 absolute shadow-lg z-10"
      [img]="slide.bg_img"
      profile="full"
      [fill]="true"
      alt=""
    >
    </ts-picture>

    <!-- Video slide -->
    <video
      *ngIf="slide.bg_video"
      (ended)="incIndex()"
      controls
      muted
      autoplay
      class="inset-0 absolute z-10 w-full h-full object-cover"
      [src]="getVideoPath(slide.bg_video)"
    ></video>

    <!-- Dark overlay -->
    <div class="absolute inset-0 bg-black opacity-20"></div>
  </div>
</div>
